module.exports = __webpack_public_path__ + "static/img/tigerh.dcc1e6a4.png";